import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../../assets/Messages.json';
import { changeDateFormat} from '../../../../Custom/Custom'
import { generateThok1 } from "../ExportPriceWagesExcel";
import priceTitle from '../../../../price.json';

const Thok1 = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [reportType, setReportType] = useState("");
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    // const token = useContext(MyContextProvider).token;
    // const decode_token = jwtDecode(token);
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };

    const config = getAuthHeaders();

    const storedLanguage = localStorage.getItem('language');

    // Get next Year
    const getNextYear = (year) => {
        const nextYear = parseInt(year) + 1;
        return `${year}-${nextYear}`;
    };

    // Get Years
    const getAllYears = () => {
        const yearsArray = [];
        for (let year = 2024; year >= 2001; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    };

    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        setYears(getAllYears());
    }, []);

    const handleYearNameChange = (e) => {
        setYearName(e.target.value);
    };

    const handleReportTypeChange = (e) => {
        setReportType(e.target.value);
    };

    const handleGenerateExcel = () => {
        if (!yearName) {
            toast.error("Please select a Survey Year", messages.COLOR_RED);
            return;
        }

        if (!reportType) {
            toast.error("Please select a Year Type", messages.COLOR_RED);
            return;
        }

        showLoading(true);
        // Prepare payload
        const payload = {
            survey_year: yearName,
            report_type: reportType, // Include report type in payload if needed
        };

        // POST request to API
        axios
            .post(`${API_URL}api/price/priceWholeSaleThok1AverageIndex`, payload, config)
            .then((response) => {
                const thok1 = response.data.data[0].GroupCodes;

                if (!thok1 || thok1.length === 0) {
                    toast.info("Data not found");
                    showLoading(false);
                    return;
                }

                let excelFileName = 'Thok1';
                const excelObjectData = {
                    fileName: excelFileName,
                    reportType: excelFileName,
                    fileType: 'xlsx',
                    sheetName: "Thok1",
                    firstRowMergeCells: "A1:P1",
                    firstRowExportData: changeDateFormat(new Date()),
                    firstRowCellNumber: 11,
                    secondRowMergeCells: "A2:P2",
                    // secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}-${parseInt(yearName) + 1}`,
                    secondRowText: 'कृषि से प्राप्त भाव  सूचकांक  - Thok1 (आधार वर्ष 2011-12=100)',
                    thirdRowMergeCells: "A3:R3",
                    thirdRowText: 'उत्तर प्रदेश के उद्योगों का रोजगार एवं परिलब्धियाँ',
                    surveyYear:yearName,
                    headerEnglishColumns: [
                     'जनपद', 'प्रतिशत', 'जुलाई', 'अगस्त', 'सितम्बर', 'अक्टूबर', 'नवम्बर', 'दिसम्बर', 'जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'औसत कृषि वर्ष', 'भारित औसत'  
                    ],
                };

                const transformedData = thok1.map(item => [
                    item.col1,
                    item.col2,
                    item.col3,
                    item.col4,
                    item.col5,
                    item.col6,
                    item.col7,
                    item.col8,
                    item.col9,
                    item.col10,
                    item.col11,
                    item.col12,
                    item.col13,
                    item.col14,
                    item.col15,
                    item.col16,
                ]);
                excelObjectData.excelRowData = transformedData;

                generateThok1(excelObjectData);

                showLoading(false);
            })
            .catch((error) => {
                console.error('API Error:', error);
                showLoading(false);
            });
    };

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.THOK1 : priceTitle.en.THOK1 }} />
                            </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">Select Year Type</label>
                                    <select
                                        name="reportType"
                                        className="form-select"
                                        onChange={handleReportTypeChange}
                                        value={reportType}
                                    >
                                        <option value="" disabled>[-Select-]</option>
                                        <option value="a">Agriculture Year</option>
                                        {/* Add other year types here if needed */}
                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                        Survey Year
                                    </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleYearNameChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years.map((ele, index) => (
                                            <option key={index} value={ele}>
                                                {getNextYear(ele)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default Thok1